(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moise-newsletter"] && !Shopify.designMode) return;
  try {
    
(() => {
  const key = 'moise-launch-welcome-2026-09-v2';
  const subscribedKey = 'moise-world-subscribed-v2';
  const init = (root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const dialog = root.querySelector('dialog');
    const form = dialog.querySelector('form');
    let priorFocus;
    let priorOverflow = '';
    const read = (storage, name) => { try { return window[storage].getItem(name); } catch { return null; } };
    const write = (storage, name, value) => { try { window[storage].setItem(name, value); } catch {} };
    const open = () => {
      if (dialog.open) return;
      priorFocus = document.activeElement;
      priorOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      dialog.showModal();
      dialog.focus({preventScroll:true});
    };
    const close = () => { if (dialog.open) dialog.close(); };
    root.querySelectorAll('[data-mw-close]').forEach(button => button.addEventListener('click', close));
    dialog.addEventListener('close', () => {
      document.body.style.overflow = priorOverflow;
      write('sessionStorage', key, '1');
      if (priorFocus && priorFocus.isConnected) priorFocus.focus({preventScroll:true});
    });
    dialog.addEventListener('click', event => {
      const box = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) close();
    });
    document.addEventListener('click', event => {
      if (event.target.closest('[data-me-open]')) { event.preventDefault(); open(); }
    });
    form.addEventListener('submit', () => write('sessionStorage', 'moise-world-form-source', 'popup'));
    root.querySelector('#moise-footer-newsletter-form').addEventListener('submit', () => write('sessionStorage', 'moise-world-form-source', 'footer'));
    if (root.querySelector('[data-mw-success]')) {
      write('localStorage', subscribedKey, '1');
      if (read('sessionStorage', 'moise-world-form-source') === 'popup') open();
    } else if (dialog.querySelector('[data-mw-error]')) {
      open();
    } else if (root.dataset.auto === 'true' && root.dataset.subscribed !== 'true' && !read('sessionStorage', key) && !read('localStorage', subscribedKey) && !window.Shopify?.designMode) {
      Promise.resolve(window.moiseMarketReady).finally(() => {
        if (window.moiseMarketRedirecting || !document.querySelector('[data-moise-home]')) return;
        const started=Date.now();
        const invite=()=>{
          if(Date.now()-started<14000 || window.scrollY<window.innerHeight*.65 || document.querySelector('dialog[open]'))return;
          window.removeEventListener('scroll',invite);
          if(!read('sessionStorage',key))open();
        };
        window.addEventListener('scroll',invite,{passive:true});
      });
    }
  };
  const boot = () => document.querySelectorAll('[data-moise-world-root]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true}); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
